// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"99b2f931","235":"03b48569","254":"19905494","463":"8de513e1","514":"2ff68082","709":"d39c967a","744":"78c29a2b","825":"dc4e5b48","913":"efd00340"}[chunkId] + ".chunk.js";
};